import { MMButton } from '@components'
import { ErrorIcon } from './ErrorIcon'

import './ErrorFallback.scss'

const ErrorFallback = ({ resetErrorBoundary }) => (
  <div className='error-fallback-wrapper'>
    <div className='error-fallback-content'>
      <ErrorIcon />
      <p>An unexpected error occurred</p>
      {resetErrorBoundary ? (
        <MMButton variant='primary' onClick={resetErrorBoundary} caption='Go back to the home page' />
      ) : null}
    </div>
  </div>
)

export default ErrorFallback
